var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReortedQuestions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inquiry",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.345,
    height: 42.345,
    viewBox: "0 0 42.345 42.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M88.391,334.9a19.424,19.424,0,0,1-2.378-2.885l-2.735,2.734,5.263,5.263,2.734-2.735A19.425,19.425,0,0,1,88.391,334.9Zm0,0",
    transform: "translate(-76.39 -304.56)",
    fill: "#1a8fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M5.133,386.3,1.09,390.34A3.722,3.722,0,0,0,6.353,395.6L10.4,391.56Zm0,0",
    transform: "translate(0 -354.348)",
    fill: "#1a8fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M123.748,0A16.748,16.748,0,1,0,140.5,16.748,16.748,16.748,0,0,0,123.748,0Zm0,29.774a13.026,13.026,0,1,1,13.026-13.026A13.041,13.041,0,0,1,123.748,29.774Zm0,0",
    transform: "translate(-98.151)",
    fill: "#1a8fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M192.545,75A10.545,10.545,0,1,0,203.09,85.545,10.557,10.557,0,0,0,192.545,75Zm1.241,18.171H191.3V90.69h2.481Zm1.75-8.417-1.75,1.958v1.5H191.3V85.764l2.382-2.664a1.532,1.532,0,1,0-2.674-1.022h-2.481a4.013,4.013,0,1,1,7,2.676Zm0,0",
    transform: "translate(-166.948 -68.797)",
    fill: "#1a8fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReortedQuestions);
export default __webpack_public_path__ + "static/media/reorted_questions.309999ff3d314c4b4236ed4e85c3f4a2.svg";
export { ForwardRef as ReactComponent };